import { useTranslation } from "react-i18next"
import { useGetPlatformStatsQuery } from "../api/platformAdminApiSlice"


export default function PlatformStats() {


    const [t, i18n] = useTranslation("global")

    // API
    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetPlatformStatsQuery()

    if(isSuccess){
        return (
            <div className="card bg-black bg-opacity-10 text-white mb-4 text-center">
                <div className="card-body">
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                        <div className="col p-2">
                            {t("entity.companies")}<br />
                            <h2 className="p-2"><i className="fa-solid fa-landmark"></i>  {data.companies}</h2>
                        </div>
                        <div className="col p-2">
                            {t("entity.businessUnits")}<br />
                            <h2 className="p-2"><i className="fa-solid fa-building-flag"></i> {data.units}</h2>
                        </div>
                        <div className="col p-2">
                            {t("entity.users")}<br />
                            <h2 className="p-2"><i className="fas fa-users"></i> {data.users}</h2>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
   

}